<div class="top-section service-page">

    <section class="healthcare-banner instool aashi">
        <div class="container">
            <div class="row hero-img-wrapper zmc">
                <div class="col-lg-7 col-md-7 col-sm-7  col-12 service-heading">
                    <div class="headtext">
                        <h1>Microsoft Native</h1>
                        <p>Microsoft Dynamics 365 is a suite of enterprise resource planning (ERP) and customer
                            relationship management (CRM) applications, offering a unified platform that integrates with
                            various Microsoft services and provides a seamless experience across different devices and
                            platforms.</p>

                        <!-- <a class="ar_contect-industries-header" routerLink="/hire-angular-js-developers.html"><span>Hire
                                Frontend Developer</span></a> -->

                    </div>
                </div>
                <div class="col-lg-5 col-md-5 col-sm-5 col-12">
                    <div class="right-img frontend-heroimg">
                        <img style="    height: 320px;" src="../../../assets/images/services/native-3-removebg-preview.png" loading="lazy"
                            alt="Ecommerce Website Development Service Header Image">
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>

<section class="services-row">
    <div class="container">
        <!-- <app-services-content-point [firstMAtchData]="firstMAtch"></app-services-content-point> -->

        <div class="softeare-developemnt-isv-main">
            <div class="row">
                <div class="col-lg-12 headingsec">
                    <h2>Microsoft Dynamics Native Integrations and Features</h2>
                    <!-- <p>It combines the traditional Office suite of applications with advanced cloud services,
                        collaboration tools, and intelligent capabilities. Here's an overview of its functionality and
                        key features</p> -->
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li class="mobi">
                            <div class="img-box-isv">
                                <img src="../../../assets/images/services/banner-1.jpg" loading="lazy"
                                    alt="Ecommerce Application Development">

                            </div>
                        </li>
                        <li>
                            <h3>Microsoft 365 Integration</h3>
                            <p>Seamless integration with Microsoft 365 for productivity and collaboration tools such as Word, Excel, Outlook, and Teams.
                            </p>
                            <h3>Power Platform Integration</h3>
                            <p>Integrates with Microsoft Power Apps, Power Automate, and Power BI for customization, automation, and analytics.
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12 softeare-developemnt-isv">
                    <ul>
                        <li>
                            <h3>AI and Insights</h3>
                            <p> Utilizes AI and machine learning for predictive insights and enhanced customer experiences.</p>
                        </li>
                        <li>
                            <h3>Unified Interface</h3>
                            <p>Provides a consistent user experience across web, mobile, and desktop applications.</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="quote-box" style="    background-color: #0d052a;">
    <div class="container">
        <div class="row">
            <div class="col-md-9">
                <h4>Are You Ready To Discuss Your Project With Us?</h4>
            </div>
            <div class="col-md-3">
                <button routerLink="/hire-react-js-developers.html">Hire Our Experts</button>
            </div>
        </div>
    </div>
</section> -->
<section class="services-row services-row-new white_bg border-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>Microsoft Dynamics Core Applications</h2>
                <!-- <p>We use best technologies to develop User Interface applications for every industry. </p> -->
            </div>
            <div class="col-lg-12 smart-software-product-isv frontend-tech ">
                <ul>
                    <li>
                        <img src="../../../assets/images/services/d-sales.png" alt="HTML">
                        <h3>Dynamics 365 Sales</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/d-marketing.png" alt="CSS">
                        <h3>Dynamics 365 Marketing</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/d-field-service.png" alt="Javascript">
                        <h3>Dynamics 365 Field Service</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/finance.png" alt="React">
                        <h3>Dynamics 365 Finance</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/d-human.png" alt="Angular">
                        <h3>Dynamics 365 Human Resources</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/d-commerce.png" alt="Vue">
                        <h3>Dynamics 365 Commerce</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/d-prject-operation.png" alt="Scss">
                        <h3>Dynamics 365 Project Operations</h3>
                    </li>
                    <li>
                        <img src="../../../assets/images/services/custom-insight.png" alt="Bootstrap">
                        <h3>Dynamics 365 Customer Service</h3>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>





<!-- <app-why-choose-us></app-why-choose-us> -->

<section class="services-row services-row-new">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 headingsec">
                <h2>key functionalities and features</h2>
                <!-- <p>Here’s what you get when you choose us as your preferred business partner:</p> -->
            </div>
        </div>
        <div class="row uses-box">
            <div class="col-lg-7 col-md-7 col-sm-12 whychoose-isv uses-conent">
                <ul>
                    <li>
                        <h3>IoT and Mixed Reality</h3>
                        <p>Integrates with IoT Hub and HoloLens for advanced features such as predictive maintenance and augmented reality.
                        </p>
                    </li>
                    <li>
                        <h3>Multi-Channel Communication</h3>
                        <p> Supports communication with customers through email, chat, social media, and other channels.
                        </p>
                    </li>
                    <li>
                        <h3>Data Integration</h3>
                        <p> Seamlessly integrates data from various sources and services, including other Microsoft services and third-party applications.</p>
                    </li>
                    <li>
                        <h3>Customization and Extensibility</h3>
                        <p>Provides tools and APIs for customizing and extending Dynamics 365 applications to meet specific business needs.</p>
                    </li>
                    <li>
                        <h3>Security and Compliance</h3>
                        <p>Ensures data security and compliance with industry standards through features such as role-based access and encryption.
                        </p>
                    </li>
                    <li>
                        <h3>Mobility</h3>
                        <p> Offers mobile apps for key Dynamics 365 applications, allowing users to access and manage data on the go.</p>
                    </li>
                </ul>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-12 img-box-container img-content">
                <div class="img-box-why-chosse">
                    <img src="../../../assets/images/services/native-2.jpg" loading="lazy" alt="Product Web Development">
                </div>
            </div>
        </div>
    </div>

</section>